export const asFileVideo = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M9.333 1.333H4c-.733 0-1.333.6-1.333 1.333v10.667c0 .733.6 1.333 1.333 1.333h8c.733 0 1.333-.6 1.333-1.333v-8l-4-4ZM4 13.333V2.666h4.666V6H12v7.333H4Zm5.333-4 1.333-.707v2.747l-1.333-.707v.667c0 .367-.3.667-.667.667H6a.669.669 0 0 1-.667-.667V8.666C5.333 8.3 5.633 8 6 8h2.666c.367 0 .667.3.667.666v.667Z" fill="#818F99"/>
  </svg>`,
  name: 'fileVideo',
};
